<template>
 <v-dialog v-model="dialogCreatenote" persistent  max-width="500px" max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
  <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">fas fa-sticky-note</v-icon>&nbsp;&nbsp;{{$t('Dialog.note.headerCreate')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="padding-left: 25px; padding-right: 25px;">

  <div style="max-height:200px; min-height:100px; margin-top: 10px;" class="scrolling-wrapper">
    <div>
      <textarea v-model="edittext" style="width: 100%; height: 190px; background: #1a222b12; padding: 20px; resize: none;border-radius: 15px;"> </textarea>
    </div>
  </div>

<div style="text-align: right;">
        <v-btn dark @click="closeDialog" class="btncancel CSChatThai" >
          {{$t('AnswerQuestion.cancel')}}
        </v-btn>
        <v-btn  dark @click="save" v-if="/\S/.test(edittext)" class="btnallow CSChatThai" :loading="loading">
          {{$t('AnswerQuestion.ok')}}
        </v-btn>
        <v-btn v-else disabled class="btnallow CSChatThai">
          {{$t('AnswerQuestion.ok')}}
        </v-btn>
      </div>


  </v-card-text>


</v-card>
</v-dialog>
</template>
<script>
// import { Momenttime } from '@/services'
import { Decode } from '@/services'

export default {
  props: {dialogCreatenote: false, tokenroom: ''},
  data: () => ({
    token: '',
    edittext: '',
    loading: false
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  methods: {
    closeDialog () {
      this.edittext = ''
      this.$emit('closeCreatenote', false)
    },
    save () {
      this.loading = true
      if (/\S/.test(this.edittext)) {
        this.axios.post(process.env.APImanage + '/createnote', {tokenuser: this.token, text: this.edittext, tokenroom: this.tokenroom}).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.$swal('', this.$t('Alert.Success.createNote'), 'success')
            this.$emit('CreateNote', 'success', response.data.create_date, response.data.note_id, response.data.tokenroom, response.data.update_date, this.edittext)
            this.closeDialog()
          } else {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          }
        }, () => {
          this.loading = false
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
    }
  },
  watch: {
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.btnallow {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.btncancel {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #e0e0e0 !important;
  color: black !important;
  text-transform: none;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.user-photonote{
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display:inline-flex;
}
input[type=textadd] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 12px 12px 12px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
textarea:focus {
    outline: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/notes/CreateNoteDialog.vue